const unformatPrice = (price) => {
  const _price = price.replace(/ /g, '')

  console.log('unformat price is deprecated')

  if (/\.|,/.test(_price)) {
    return _price.split(/\.|,/).map((price, index) => {
      if (index) {
        if (!price.length) {
          return `${price}00`
        }
        else if (price.length === 1) {
          return `${price}0`
        }
      }

      return price
    }).join('')
  }

  return Number(price) * 100
}


export default unformatPrice
